/* ============================================================================
   ADD TO CART — show live price in the button:  "ADD TO CART | $34.99"

   SETUP (same as the subscription widget):
   1. Edit code → Assets → Add a new asset → blank file → name it  atc-price.js
      → paste this whole file in → Save.
   2. In  layout/theme.liquid , just before </body>, add:
        <script src="{{ 'atc-price.js' | asset_url }}" defer></script>

   It reads whatever price the theme is currently showing (variant, pack, or
   subscription discount) and keeps the button in sync. Hides the price when a
   product is sold out. Works on every PDP.
   ============================================================================ */
(function () {
  var LABEL_SELECTOR  = '.product-form__submit';
  var SEPARATOR       = '  |  ';

  function readPrice(scope) {
    if (!scope) return null;
    var block = scope.querySelector('.price:not(.price--unavailable)') ||
                scope.querySelector('.price');
    if (!block) return null;
    var el = block.classList.contains('price--on-sale')
      ? block.querySelector('.price-item--sale')
      : block.querySelector('.price-item--regular');
    if (!el) el = block.querySelector('.price-item');
    var text = el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    return text || null;
  }

  // Read the price the theme is currently displaying. The price block usually
  // sits OUTSIDE the <form>, so we scope to the whole product section (which
  // contains both the price and the button), then fall back to the document.
  function priceForButton(btn) {
    var scope = btn.closest('product-info, [id^="ProductInfo-"], .product, .product__info-wrapper, section');
    return readPrice(scope) || readPrice(document);
  }

  function update() {
    document.querySelectorAll(LABEL_SELECTOR).forEach(function (btn) {
      // Most themes wrap the button text in a <span>; if not, use the button.
      var label = btn.querySelector('span') || btn;

      // Remove any duplicate price spans. The sticky/floating cart clones the
      // button, which can leave more than one .atc-price behind (the bug that
      // showed "| $34.99 USD | $31.49 USD"). Keep one, drop the rest.
      var existing = btn.querySelectorAll('.atc-price');
      for (var i = 1; i < existing.length; i++) existing[i].remove();

      // Look for the price span across the WHOLE button, not just one span.
      var priceSpan = btn.querySelector('.atc-price');
      if (!priceSpan) {
        priceSpan = document.createElement('span');
        priceSpan.className = 'atc-price';
        priceSpan.style.fontWeight = '600';
        label.appendChild(priceSpan);
      }

      var soldOut = btn.hasAttribute('disabled');
      var price = priceForButton(btn);
      var desired = (price && !soldOut) ? SEPARATOR + price : '';

      // Only write when it actually changed — writing identical text still
      // fires a DOM mutation, which would re-trigger the observer in an
      // infinite loop and freeze the page (incl. the Add to Cart click).
      if (priceSpan.textContent !== desired) priceSpan.textContent = desired;
    });
  }

  var raf;
  function schedule() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(update);
    setTimeout(update, 60);
    setTimeout(update, 250);
  }

  function start() {
    update();
    setTimeout(update, 400);

    // Watch body (stable) — variant changes replace the product section.
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('change', schedule, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();